import { IgButton } from "@intelligems/ig-theme/IgButton";
import { useRefreshShopifyScopes } from "@src/api/user-auths/login";
import { useMissingShopifyScopes } from "@src/components/LimitAccess/hooks";
import { getShopifyScopeAdvantages } from "@src/components/LimitAccess/shopify-scope-advantages";
import { IgAppBanner } from "@src/components/Utils/IgAppBanner";
import { mpConfirmShopifyPermissionsClicked } from "@src/utils/mixpanel";

import { VariantProp } from "./types";

export const MissingShopifyOrgIdAlert = ({
  additionalAlert,
  endContent,
}: VariantProp) => {
  const refreshShopifyCredentials = useRefreshShopifyScopes();

  return (
    <IgAppBanner
      variant={additionalAlert ? "secondary" : "alert"}
      title="Intelligems isn't installed on this account."
      message="Visit the Shopify app store to install the app."
      buttons={[
        <IgButton
          size="extraSmall"
          variant="contained"
          key="missingIntelligemsMessage"
          color={additionalAlert ? "primary" : "secondary"}
          onClick={() => refreshShopifyCredentials.mutate({})}
          disabled={refreshShopifyCredentials.isPending}
        >
          Reconnect app
        </IgButton>,
      ]}
      endContent={endContent}
    />
  );
};

export const ShopifyPermissionsAlert = ({
  additionalAlert,
  endContent,
}: VariantProp) => {
  const refreshShopifyCredentials = useRefreshShopifyScopes();
  const missingScopes = useMissingShopifyScopes();

  // Every advantage the missing scopes unlock, not just the first one we
  // recognize, so a new scope only ever needs an entry in the advantage map —
  // and a single generic line once they span more than the map will name.
  const advantages = getShopifyScopeAdvantages(missingScopes).join(", ");
  const title = `To access ${advantages}, `;

  return (
    <IgAppBanner
      title={title}
      message="confirm new permissions in Shopify."
      variant={additionalAlert ? "secondary" : "info"}
      buttons={[
        <IgButton
          key="update-permissions"
          size="extraSmall"
          variant="contained"
          color={additionalAlert ? "primary" : "secondary"}
          loading={refreshShopifyCredentials.isPending}
          onClick={() => {
            mpConfirmShopifyPermissionsClicked(missingScopes);
            refreshShopifyCredentials.mutate({});
          }}
        >
          Confirm Permissions
        </IgButton>,
      ]}
      endContent={endContent}
    />
  );
};
